
export enum MFAVerifyType {
    EmailVerifyType = 'email',
    PhoneVerifyType = 'sms'
}
